import BulletTypography from '@/common/components/base/typography/BulletTypography.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { DefaultDetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import { Box, Flex } from 'styled-system/jsx';

export default ({
  value,
  keyName,
  backgroundColor = 'black-3',
  hasBullet = true,
  valueClassName,
  dirLtr,
}: Omit<DefaultDetailCardItemData, 'value'> & { value: string }) => {
  return (
    <Flex justifyContent="space-between">
      {hasBullet ? (
        <BulletTypography
          flexShrink={0}
          backgroundColor={backgroundColor}
          textStyle="b2"
          color="black-3"
        >
          {keyName}
        </BulletTypography>
      ) : (
        <Typography flexShrink={0} textStyle="b2" color="black-3">
          {keyName}
        </Typography>
      )}
      <Box
        textAlign="right"
        textWrap={{ base: 'nowrap' }}
        maxW={160}
        overflow="hidden"
      >
        <Typography
          textStyle="b2"
          dir={dirLtr ? 'ltr' : 'rtl'}
          className={valueClassName}
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'break-spaces',
          }}
        >
          {value}
        </Typography>
      </Box>
    </Flex>
  );
};
